import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useProductNode from '../_PRODUCT/useProductNode.jsx'
import meta from './metaIsrf.mjs'
import Model from './ModelIsrf.mjs'
import PropertiesPane from './PropertiesPaneIsrf.jsx'
import api from './apiIsrf.mjs'

export default () => {
    const ProductNode = useProductNode()

    return extendNode(ProductNode, {
        ...meta,
        api,
        Model,
        PropertiesPane,

        _pushDataSlots: {
            isrfReqs: [],
        },

        _getCategories(map, node) {
            return [
                'ISRF_BIZ',
                'ISRF_REQ',
                'ISRF_UC',
                'ISRF_BRANCH',
                'ISRF_DOC',
            ]
        },

        _getShape(map, node) {
            return 'Rectangle'
        },

        _getThemeColor(map, node) {
            return Color.LIGHT_ORANGE
        },
    })
}
